<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories" style="color:black">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">Области</div>
                    </div>
                    <div class="region-map">
                      <div id="map" style="width: 100%; height: 1000px"></div>
                    </div>
                    <div class="head-panel indent-top visibility">
                      <router-link to="/directories/regions/new" style="color:black">
                        <div class="add-table-string"><i>+</i>Добавить область</div>
                      </router-link>
                    </div>
                    <table cellpadding="0" cellspacing="0" class="region-table">
                      <thead>
                      <tr>
                        <td>Наименование области</td>
                        <td>Надбавка, час.</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr title="Редактировать" v-for="region in regions"
                          @click="$router.push('/directories/regions/' + region.id)">
                        <td class="name">{{region.name}}</td>
                        <td>{{region.surcharge}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'

    export default {
  name: 'Regions',
  components: { HeaderDispatcher, MenuDispatcher },

  data () {
    return {
      regions: {},
      map: {}
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    api
      .getRegions()
      .then(regions => {
        if (regions) {
          this.regions = []
          this.regions = regions

          ymaps.ready(() => {
            require('@/utils/ymaps/calculateArea.min.js')
            require('@/utils/ymaps/polylabel.min.js')
            this.initRegionsMap(this.regions)
          })
        }
      })
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    initRegionsMap (regs) {
      let regionsForMap = []

      for (let i = 0; i < regs.length; i++) {
        regionsForMap.push(regs[i].points.reduce((l, x) => {
          l.push([x.lat, x.lng])
          return l
        }, []))
      }

      ymaps.ready(['polylabel.create']).then(() => {
        let map = new ymaps.Map('map', {
          center: [55.796289, 49.108795],
          zoom: 12,
          controls: ['zoomControl', 'searchControl', 'fullscreenControl']
        },
        { suppressMapOpenBlock: true }
        )
        let regionsCollection = new ymaps.GeoObjectCollection()
        for (let i = 0; i < regs.length; i++) {
          let pol = new ymaps.GeoObject({
            // Описываем геометрию геообъекта.
            geometry: {
              // Тип геометрии - "Многоугольник".
              type: 'Polygon',
              // Указываем координаты вершин многоугольника.
              coordinates: [
                // Координаты вершин внешнего контура.
                regs[i].points.reduce((l, x) => {
                  l.push([x.lat, x.lng])
                  return l
                }, [])
              ]
            },
            properties: {
              name: regs[i].surcharge
            }
          }, {
            labelDefaults: 'light',
            labelLayout: '<div style="font-size: 30px">+&nbsp;{{properties.name}}&nbsp;ч.</div>',
            // это не работает
            labelTextSize: {
              '0_4': 22,
              '5_23': 30
            }
          })

          regionsCollection.add(pol)
        }
        map.geoObjects.add(regionsCollection)
        const polylabel = new ymaps.polylabel.create(map, regionsCollection)
      }
      ).catch(e => {
        // элегантное решение для загрузки надписей на многоугольниках при повторном открытии окна "Регионы"
        this.$router.go('/directories/regions')
      })
    }
  }
}
</script>
